import Stepper from '@keyvaluesystems/react-stepper';

export interface Step {
  stepLabel: string;
  stepDescription?: string;
}

interface CustomStepperProps {
  currentStep: number;
  steps: Step[];
}

const CustomStepper = ({ currentStep, steps }: CustomStepperProps) => {
  // Define your custom styles once
  const styles = {
    LineSeparator: () => ({
      backgroundColor: '#FDB640',
    }),
    ActiveNode: () => ({
      backgroundColor: '#FDB640',
    }),
    CompletedNode: () => ({
      backgroundColor: '#EFA005',
    }),
    InactiveLineSeparator: () => ({ backgroundColor: '#DDDDDD' }),
    Bubble: () => ({ backgroundColor: '#EFA005' }),
    ActiveBubble: () => ({ backgroundColor: '#EFA005' }),
    InActiveBubble: () => ({ backgroundColor: '#DDDDDD' }),
  };

  // Transform steps to include "completed"
  const stepsArray = steps.map((step, index) => ({
    ...step,
    completed: currentStep > index,
  }));

  return (
    <div className="bg-white shadow-card h-fit p-6 min-w-[0px] lg:max-w-[400px] flex sm:gap-0 items-center justify-center">
      <Stepper
        steps={stepsArray}
        currentStepIndex={currentStep}
        styles={styles}
      />
    </div>
  );
};

export default CustomStepper;
